<template>
    <tw-card title="My Leagues" class="transition duration-500 ease-in-out dark:text-white items-center" height="dark:bg-gray-900">
        <dl>
            <league v-for="league in leagues" :league="league" :user="user" />
        </dl>

        <div class="flex sm:mt-2 justify-end p-4 sm:p-0 justify-center">
            <button class="border border-white rounded py-2 px-4 flex items-center text-white" @click="joinLeagueModal = true">Join League <CalendarIcon class="ml-2 w-4 text-white" /></button>
            <button class="bg-racing-stars-yellow text-gray-900 rounded py-2 px-4 flex items-center ml-2" @click="createLeagueModal = true">Create League <PlusCircleIcon class="ml-2 w-4 text-gray-900" /></button>
        </div>
    </tw-card>

    <create :show="createLeagueModal" @close="getLeagues()" />
    <join :show="joinLeagueModal" @close="getLeagues()" />
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import TwCard from '@/Global/Elements/TwCard.vue'
import League from '@/Global/Leagues/Partials/League.vue'
import { PlusCircleIcon, CalendarIcon } from '@heroicons/vue/outline'
import Create from '@/Global/Leagues/Partials/Create.vue'
import Join from '@/Global/Leagues/Partials/Join.vue'

export default {
    props: {
        user: {
            type: Object,
            default: {}
        }
    },
    components: {
        TwCard,
        League,
        PlusCircleIcon,
        CalendarIcon,
        Create,
        Join,
    },

    setup(props) {
        const leagues = ref([])
        const createLeagueModal = ref(false)
        const joinLeagueModal = ref(false)

        const getLeagues = () => {
            axios.get(route('api.leagues.index'))
                .then(response => {
                    leagues.value = response.data

                    createLeagueModal.value = false
                    joinLeagueModal.value = false
                })
        }

        onMounted(() => {
            getLeagues()
        })

        return {
            leagues,
            getLeagues,
            createLeagueModal,
            joinLeagueModal,
        }

    }
}

</script>
